import {
  useMemo } from "react";
  import { useTranslation } from "react-i18next";
  import {
  CloudServerOutlined,
  ApiOutlined,
  LineChartOutlined,
  RiseOutlined,
  FundOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByIndex: Record<number, JSX.Element> = {
  0: <CloudServerOutlined />,
  1: <ApiOutlined />,
  2: <LineChartOutlined />,
  3: <FundOutlined />,
};

const BenefitsSection = () => {
  const { t } = useTranslation("erpMini");

  const items = useMemo(() => {
    const raw = t("benefits.items", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ title: string; desc: string }>;
  }, [t]);

  return (
    <section className="dev-erpMini-section dev-erpMini-benefits-section">
      <div className="dev-erpMini-section-inner">
        <h2 className="dev-section-h2 dev-erpMini-section-h2">
          <span className="dev-erpMini-section-h2-icon dev-erpMini-section-h2-icon--amber" aria-hidden>
            <RiseOutlined />
          </span>
          <span>{t("benefits.title")}</span>
        </h2>

        <div className="dev-erpMini-benefits-grid">
          {items.slice(0, 5).map((item, idx) => (
            <div key={idx} className="dev-erpMini-benefit-card">
              <div className="dev-erpMini-benefit-left">
                <span className="dev-erpMini-benefit-number">{String(idx + 1).padStart(2, "0")}</span>
                <span className="dev-erpMini-benefit-icon">{iconByIndex[idx] ?? null}</span>
              </div>
              <div className="dev-erpMini-benefit-body">
                <div className="dev-erpMini-benefit-title">{item.title}</div>
                <div className="dev-erpMini-benefit-desc">{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
